import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { dashboardAction, packageAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import WaitScreen from "../LodingScreen/WaitScreen";
import SeoAdd from "../Seo/SeoAdd";
import { pkjInfo } from "./array";
import { useTranslation } from "react-i18next";
import { FDiscount } from "../../constant/utils";
import BookButton from "../BookATest/BookButton";
import GurugramForm from "../GurugramLab/gurugramForm";
import SectionLoader from "../LodingScreen/SectionLoader";
import WhyOncqPre from "../preventiveHealthPackage/WhyOncqPre";
import SendQueryModal from "../packageDetail/SendQueryModal";
import SeoFooterContent from "../Seo/SeoFooterContent";
import SeoHeaderContent from "../Seo/SeoHeaderContent";
import { ShareTestModal } from "../ShareTestModal/indes";
interface LocationState {
  tabs?: string;
  scrollToSection?: boolean;
}
function PreventiveHealthPackage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<LocationState>();
  const myElementRef = useRef<HTMLDivElement | null>(null);
  const [details, setDetails] = useState<any[]>([]);
  const [packages, setPackages] = useState<any[]>([]);
  const [shareModal, setShareModal] = useState(false);
  const [selectedTest, setSelectedTest] = useState<any>(null);
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [tests, setTests] = useState<any[]>([]);
  const [code, setCode] = useState<any>("");
  const packageData = useSelector((state: any) =>
    state.package.list ? state.package.list : {}
  );
    const getSelectTest = `https://oncquestlabs.com${ROUTE.PACKAGEDETAILS}/${selectedTest?.Slug}`;
  const [pricePSort, setPricePSort] = useState("low");
  useEffect(() => {
    const timer = setTimeout(() => {
      if (location.state?.scrollToSection && myElementRef.current) {
        myElementRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [location.state?.scrollToSection]);

  useEffect(() => {
    if (pkjInfo) {
      setDetails(pkjInfo);
    }
    dispatch(
      packageAction.listPackageAction({
        SearchTerm: "",
        SubCategories: "",
        Offset: 0,
        Limit: 20,
      })
    );
    return () => {};
  }, [pkjInfo]);
  useEffect(() => {
    if (packageData?.Packages) {
      setPackages(packageData?.Packages);
    }
  }, [packageData?.Packages]);
  const handleModalOpen = (code: any) => {
    setCode(code);
    setModalIsOpen(true);
  };
  function GetPKGColorTitle1(title: any = "") {
    let _title: any[] = title?.split(" ");
    let len: number = _title?.length;
    let title1 = _title?.slice(Math.ceil(2))?.join(" ");
    let title2 = title.replace(title1, "");
    return (
      <>
        <span style={{ color: "#FFFFFF" }}>{title2}</span>
      </>
    );
  }
  function GetPKGColorTitle2(title: any = "") {
    let _title: any[] = title?.split(" ");
    let len: number = _title?.length;
    let title1 = _title?.slice(Math.ceil(2))?.join(" ");
    let title2 = title.replace(title1, "");
    return (
      <>
        <span style={{ color: "#f6821f" }}>{title1}</span>
      </>
    );
  }
  const getTestShareURL = (Id: number) => {
    const packageData = packages.find((item) => item.Id === Id);
    console.log("packageData", packageData);
    if (packageData) {
      setSelectedTest(packageData);
      setShareModal(true);
    }
  };

  const handlePricePackageSort = (e: any) => {
    setPricePSort(e.target.value);
  };
  function Psort() {
    if (packageData?.Packages && packageData?.Packages?.length > 0) {
      let arr: any[] = packageData?.Packages;
      let newArr: any[] = [];
      if (pricePSort === "low") {
        newArr = [...arr]?.sort(
          (a: any, b: any) => a?.SellingPrice - b?.SellingPrice
        );
      } else if (pricePSort === "high") {
        newArr = [...arr]?.sort(
          (a: any, b: any) => b?.SellingPrice - a?.SellingPrice
        );
      } else if (pricePSort === "asc") {
        newArr = [...arr]?.sort((a: any, b: any) =>
          a?.PackageName?.localeCompare(b?.PackageName, "fr", {
            ignorePunctuation: true,
          })
        );
      }
      setPackages(newArr);
    } else {
      setPackages(packageData?.Packages);
    }
  }
  useEffect(() => {
    Psort();
  }, [packageData?.Packages, pricePSort]);

  // const scrpt= `!function(px){function e(t,e,c){var n="",r="";try{""!=(n=function(t,e){try{var c={};e.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(t,e,n){c[e]=n});return c.hasOwnProperty(t)?c[t]:""}catch(t){return""}}(t,c))?function(t,e,c){try{var n,r;c?((n=new Date).setTime(n.getTime()+864e5),r="; expires="+n.toGMTString()):r="",document.cookie=t+"="+e+r+";Path=/"}catch(t){}}(e,n,1):n=function(t){try{var e=document.cookie.match(new RegExp("(^| )"+t+"=([^;]+)"));if(e)return e[2]}catch(t){}return null}(e),r=""!=n&&null!=n?"&"+t+"="+n:"&"+t+"="}catch(t){}return r}var c="",n="",r="";try{n=e("ad","acf",c=window.location.href),r=e("col_ci","col_ci",c)}catch(t){console.log(t)}var a="https://ade.clmbtech.com/cde/eventTracking.htm?pixelId="+px+"&_w=1&_t=2"+n+r+"&rd="+(new Date).getTime();(new Image).src=a}('14427');`
  //  const noscrpt =``
  return (
    <>
      <img
        height="1"
        width="1"
        src="https://ade.clmbtech.com/cde/eventTracking.htm?pixelId=14427&_w=1&_t=2"
        style={{ display: "none" }}
      />
      <SeoAdd slug={ROUTE.PREVENTIVEHEALTHPKJ} />
      <BreadCrumb page={t("preventive_title")} data={{ slug: "", path: "#" }} />
      <section className="team-section">
        <div className="container">
          <div className="text-center">
            <img
              className="scale for-banner-radius"
              src="/assets/img/php_banner.jpg"
              alt=""
            />
          </div>
          <section className="Seo-content">
            <SeoHeaderContent />
          </section>
          <div className="row mt-25">
            <div className="col-md-12 col-lg-5">
              <GurugramForm pageSource="Preventive Health Packages" />
            </div>
            <div className="col-md-12 col-lg-7">
              <div className="headingmains text-center heading-main-prev">
                <h1 className="right aos-init">
                  Preventive Health Check-up Packages
                </h1>
              </div>
              <div className="w-100 prev-helath-con">
                <p>
                  A preventive body checkup is like a thorough health check for
                  your entire body. It's all about making sure your important
                  organs, like your heart, lungs, and kidneys, are doing well.
                  These checkups, sometimes called Inner Fitness tests, are
                  really good at finding health problems early so we can deal
                  with them before they become a big deal. This way, we can stop
                  these problems from causing serious issues in the future.
                </p>
                <p>
                  The Inner Fitness tests do two important things: they can spot
                  diseases, and they help stop future health issues from
                  growing. If you get these check-ups regularly, you can keep an
                  eye on your health numbers and take action to stay healthy.
                  It's like being a step ahead in looking after your well-being.
                </p>
                <p>
                  These tests are not just about finding existing problems –
                  they also help predict future health issues. By studying
                  important health signs, they give you smart advice on how to
                  live a healthy life. This way, you can catch possible health
                  risks early and take steps to stay healthy and enjoy life
                  more.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-25">
            {/* <div className="col-md-12">
              <WhyOncqPre />
            </div> */}
          </div>
          <div className="tab-content" ref={myElementRef}>
            {/* <div className="mt-25 text-center"> */}
              {/* <h2>{t("preventive_title")}</h2> */}
              {/* <div className="mt-25"> */}
                {/* <p className="text-center dull_heading pb-3">
              When the age of a person exceeds 50 years, it becomes very important to take care of one’s health as she enters the senior citizen age. With age, the metabolism and functioning of the body become slow.
              </p> */}
              {/* </div> */}
            {/* </div> */}
            {/* <div>
              {packages?.length > 0 && (
                <div className="form-group d-flex flex-row justify-content-end align-items-center">
                  <div className="text-center f-14 mr-3">{t("sort_by")}</div>
                  <select
                    id="inputState"
                    className="form-control rounded-pill sort_select"
                    value={pricePSort}
                    onChange={handlePricePackageSort}
                  >
                    <option value="low">{t("price_lth")}</option>
                    <option value="high">{t("price_htl")}</option>
                    <option value="asc">{t("atz")}</option>
                  </select>
                </div>
              )}
            </div> */}
           {packageData && Object.keys(packageData)?.length > 0 ? (
  <>
    {packageData && Array.isArray(packageData?.Packages) && (
      <div
        className="equal_clm h-services py-3"
        style={{
          marginTop: "0px",
        }}
      >
        {packages && (
          <>
            {packages && packages.length > 0 ? (
              // Sort packages alphabetically by PackageName
              packages
                .slice() // Create a shallow copy to avoid mutating the original array
                .sort((a, b) => a.PackageName.localeCompare(b.PackageName)) // Sort alphabetically
                .map((item, i) => (
                  <div
                    className="infobox_wrapper pkj_wrap_box"
                    key={i}
                  >
                    <div>
                      <div>
                        {FDiscount(item?.MRP, item?.SellingPrice) ? (
                          <div className="dis_icon text-center">
                            <img
                              src="/assets/img/discount.jpeg"
                              className="scale"
                            />
                            <span className="img_text_center">
                              {FDiscount(item?.MRP, item?.SellingPrice)}{" "}
                              <br />
                              OFF
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                        <div
                          style={{
                            height: "100%",
                            marginBottom: "6rem",
                          }}
                        >
                          <div className="d-flex justify-content-center align-items-center">
                            <div className="infobox_icon_container cust-health-pkg-head">
                              <img
                                src="/assets/img/pre-card-icon.png"
                                className="scale circle_img"
                              />
                              <h3 className="infobox_title text-uppercase mb-2">
                                {GetPKGColorTitle1(item?.PackageName)}
                              </h3>
                            </div>
                            <div>
                              <p
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  getTestShareURL(item.Id);
                                }}
                              >
                                <img
                                  src="/assets/img/share-icons-tests.png"
                                  alt="Share Icon"
                                  className="share-icons-test"
                                />
                              </p>
                            </div>
                          </div>

                          <h3 className="infobox_title text-uppercase mb-2">
                            {GetPKGColorTitle2(item?.PackageName)}
                          </h3>
                          {item?.ComponentCount ? (
                            <div className="infobox_lines mt-1">
                              <img
                                src="/assets/img/parameter.png"
                                className="scale_booknow"
                              />
                              {item?.ComponentCount
                                ? item?.ComponentCount
                                : 0}
                              {" Parameter(s) covered"}
                            </div>
                          ) : (
                             
                            ""
                            
                          )}

                          {item?.PackageCode ? (
                                  <div className="infobox_lines">
                                    {" "}
                                    <img
                                      src="/assets/img/parameter.png"
                                      className="scale_booknow"
                                    />
                                    {item?.PackageCode}
                                  </div>
                                ) : (
                                  ""
                                )}
                          
                          <div className="infobox_lines">
                            <img
                              src="/assets/img/daily.png"
                              className="scale_booknow"
                            />
                            {/* {item?.ReportTAT} */}
                            {/* {item?.Days === 0
                                    ? "Same Day"
                                    : item?.Days !== null &&
                                        item?.Days !== undefined
                                      ? `${item.Days} Days`
                                      : ""} */}
                                      {item?.Days}
                          </div>
                          {item?.SampleReport && (
                            <a
                              href={item?.SampleReport}
                              target="_blank"
                              className="infobox_lines"
                            >
                              <img
                                src="/assets/img/report.png"
                                className="scale_booknow"
                              />
                              {t("sample_report")}
                            </a>
                          )}
                          <Link
                            to={`${ROUTE.PACKAGEDETAILS}/${item?.Slug}`}
                            className="moreButton"
                          >
                            {t("more_btn")}
                          </Link>
                          <div className="d-flex mb-3 justify-content-between align-items-baseline">
                            <div>
                              {item?.MRP !== item?.SellingPrice && (
                                <span className="price-redtext">
                                  ₹{`${item?.MRP}`}
                                </span>
                              )}{" "}
                              <span className="price-bluetext">
                                ₹{`${item?.SellingPrice}`}
                              </span>
                            </div>
                            {/* <div>
                              <span className="price-greentext">
                                {t("save")} ₹
                                {item?.MRP - item?.SellingPrice}
                              </span>
                            </div> */}
                          </div>
                          <div className="book-test-button test-btn">
                            <BookButton
                              type={"package"}
                              data={item}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <div className="singl_clm text-center text-dark fs-20">
                No Package Data Available
              </div>
            )}
          </>
        )}
      </div>
    )}
  </>
) : (
  <SectionLoader />
)}
            <div className="row">
              <div className="col-12">
                <div className="headingmains text-center pb-3">
                  <h3 className="right aos-init pb-2">
                    {t("articles_resources_well")}
                  </h3>
                  <div className="row">
                    <p className="text-center pl-2 pr-2">
                      {t("our_expert_advice")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row testimonial_list">
              {details &&
                details?.length > 0 &&
                details?.map((item: any, i: any) => (
                  <div className="col-sm-12 col-md-6 col-lg-3" key={i}>
                    <div className="h-services h-serMo-mt">
                      <div className="infobox_wrapper doctor_card">
                        <a
                          className="text-center"
                          target="__blank"
                          href={item?.slug}
                        >
                          <img className="scale" src={item?.listImg} alt="" />
                          <h6 className="pt-3 text-left">{item?.heading}</h6>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <section className="bg-package pathlogy-content test-details-content p-4 mb-3">
              <SeoFooterContent />
            </section>
          </div>
        </div>
      </section>
      <SendQueryModal
        modalIsOpen={modalIsOpen}
        setModalIsOpen={setModalIsOpen}
        test={false}
        code={code}
      />
      <ShareTestModal
        shareModal={shareModal}
        setShareModal={setShareModal}
        selectedTest={selectedTest}
        getSelectTest={getSelectTest}
      />
    </>
  );
}

export default PreventiveHealthPackage;
